/**
 * ч.1108 (зауваження власника): пояснення для прав, які сервер не перевіряє, —
 * не всі вони «поки не діють». Джерело істини — поле `kind` довідника прав.
 */
export type PermissionKind = 'enforced' | 'ui' | 'platform' | 'reserved';

export const PERM_KIND_NOTE: Record<Exclude<PermissionKind, 'enforced'>, string> = {
  platform: 'системне — керує платформа',
  ui: 'діє в інтерфейсі',
  reserved: 'поки не діє',
};

export const PERM_KIND_SUMMARY: Record<Exclude<PermissionKind, 'enforced'>, string> = {
  platform: 'системних',
  ui: 'діють лише в інтерфейсі',
  reserved: 'поки не діють',
};

export function permKind(it: { kind?: string; enforced?: boolean } | undefined): PermissionKind {
  if (!it) return 'enforced';
  if (it.kind === 'ui' || it.kind === 'platform' || it.kind === 'reserved') return it.kind;
  return it.enforced === false ? 'reserved' : 'enforced';
}

/** Текст у дужках після назви права (порожньо — звичайне право). */
export function permKindNote(it: { kind?: string; enforced?: boolean } | undefined): string {
  const k = permKind(it);
  return k === 'enforced' ? '' : PERM_KIND_NOTE[k];
}
